import { PortableText } from "@portabletext/react"
import { serializers } from "../../Serializers"

const SectionTwoCol = ({ section }: any) => {
  const { listItems } = section
  return (
    <div className="max-w-full px-4 lg:max-w-5xl xl:max-w-7xl mx-auto lg:text-left">
      <div className="m-4 flex flex-wrap">
        {listItems.map((item: any, index: number) => {
          return (
            <div
              key={index}
              className="overflow-hidden flex flex-col  mb-4 w-full sm:w-1/2 mb-10"
            >
              {/* Content for the column */}
              {item._rawContent.map((i: any, idx: number) => (
                <PortableText key={idx} components={serializers} value={i} />
              ))}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SectionTwoCol
